<div class="elmt-tabs-container">
  <div class="pb-[20px]">
    <app-tabs [tabs$]="tabs$" data-cy="elmt-tabs"></app-tabs>
  </div>
  <router-outlet></router-outlet>
</div>
